/*
 * Module for the Service Purhase Contribution Allocation tab
*/

rs.module("content/participant/member/servicepurchase/contributionallocation",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, contributionGrid, backendUrls, editAllowed) {

            var _executeSelectionChanged = false;

            $.js(jsSelectors.addLink, { required: false }).click(function () {

                contributionGrid.selectedValues = null;
                loadContributionAllocationDetail(null);
            });

            contributionGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    loadContributionAllocationDetail(values[0]);
                }

                _executeSelectionChanged = true;
            });

            function loadContributionAllocationDetail(contributionAllocationKey) {

                $.get(
                    {
                        url: backendUrls.loadContributionAllocation,
                        data: {
                            contributionAllocationKey: contributionAllocationKey,
                            orgRefNumber: $.js(jsSelectors.orgRefNumberHiddenField).val(),
                            editAllowed: editAllowed
                        },
                        clearEventBanner: true

                    }).done(function (result) {
                        $.js(jsSelectors.contributionForm).html(result);
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);